import { defaultApi, api, apiWithCache } from './config'

const setAuthorizationHeader = (token) => {
    api.defaults.headers.Authorization = "Bearer " + token;
    apiWithCache.defaults.headers.Authorization = "Bearer " + token;
};

function APIError(error) {
    this.message = error.message
    this.name = String(error.response.status) + ' API response'
    this.status = error.response.status;
    this.data = error.response.data;
}

const throwerror = (error) => {
    if (error.response !== undefined && error.response.status !== undefined && error.response.status) {
        throw new APIError(error)
    } else {
        throw Error(error)
    }
}

const get = (url, config = null) => {
    let finalUrl = url
    if (String(url).includes('?')) {
        finalUrl = url + '&_t=' + Date.now()
    } else {
        finalUrl = url + '?_t=' + Date.now()
    }
    const token = String(localStorage.getItem('bearer_token'))
    config = config === null ? { ...api.defaults } : { ...api.defaults, ...config }
    config = { ...config, headers: { 'Authorization': 'Bearer ' + token } }
    return api.get(finalUrl, config).then((response) => { return response }).catch((error) => throwerror(error))
}

const defaultget = (url) => {
    let finalUrl = url
    if (String(url).includes('?')) {
        finalUrl = url + '&_t=' + Date.now()
    } else {
        finalUrl = url + '?_t=' + Date.now()
    }
    return defaultApi.get(finalUrl).then((response) => { return response }).catch((error) => throwerror(error))
}

const post = (url, payload, config = null) => {
    let finalUrl = url
    if (String(url).includes('?')) {
        finalUrl = url + '&_t=' + Date.now()
    } else {
        finalUrl = url + '?_t=' + Date.now()
    }
    const token = String(localStorage.getItem('bearer_token'))
    config = config === null ? { ...api.defaults } : { ...api.defaults, ...config }
    config = { ...config, headers: { 'Authorization': 'Bearer ' + token } }
    return api.post(finalUrl, payload, config).then((response) => { return response }).catch((error) => throwerror(error))
}

const defaultpost = (url, payload) => {
    let finalUrl = url
    if (String(url).includes('?')) {
        finalUrl = url + '&_t=' + Date.now()
    } else {
        finalUrl = url + '?_t=' + Date.now()
    }
    return defaultApi.post(finalUrl, payload).then((response) => { return response }).catch((error) => throwerror(error))
}

const Service = { baseURL: api.defaults.baseURL, get, defaultget, post, defaultpost, setAuthorizationHeader }

export default Service
